import {useEffect, useRef} from "react";
import {useMap} from "react-leaflet";

const ZoomListener = ({mapLoaded}) => {
    const map = useMap();
    const zoomedRef = useRef(false);

    useEffect(() => {
        if (!map) return;

        if (!mapLoaded) {
            zoomedRef.current = false;
            return;
        }

        if (zoomedRef.current) return;

        const zoomToMaxMinusTwo = () => {
            const maxZoom = map.getMaxZoom();
            const minZoom = map.getMinZoom?.();
            if (typeof maxZoom !== "number") return;

            const targetZoom = typeof minZoom === "number" ? Math.max(minZoom, maxZoom - 2) : maxZoom - 2;
            map.setZoom(targetZoom);
            zoomedRef.current = true;
        };

        map.whenReady(zoomToMaxMinusTwo);
    }, [map, mapLoaded]);

    return null;
};

export default ZoomListener;
